
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#16A59E","fill-rule":"evenodd","d":"M5.667 0h-4.25C.633 0 0 .633 0 1.417v4.25c0 .782.633 1.416 1.417 1.416h4.25c.783 0 1.416-.634 1.416-1.416v-4.25C7.083.635 6.45 0 5.667 0zm9.916 0h-4.25c-.783 0-1.416.633-1.416 1.417v4.25c0 .782.633 1.416 1.416 1.416h4.25c.784 0 1.417-.634 1.417-1.416v-4.25C17 .635 16.367 0 15.583 0zM5.667 9.917h-4.25C.633 9.917 0 10.55 0 11.333v4.25C0 16.365.633 17 1.417 17h4.25c.783 0 1.416-.635 1.416-1.417v-4.25c0-.782-.633-1.416-1.416-1.416zm9.916 0h-4.25c-.783 0-1.416.633-1.416 1.416v4.25c0 .782.633 1.417 1.416 1.417h4.25c.784 0 1.417-.635 1.417-1.417v-4.25c0-.782-.633-1.416-1.417-1.416z"}})])
          )
        }
      }
    